import { render, staticRenderFns } from "./PostDocReview.vue?vue&type=template&id=4024f3b8&scoped=true&"
import script from "./PostDocReview.vue?vue&type=script&lang=js&"
export * from "./PostDocReview.vue?vue&type=script&lang=js&"
import style0 from "./PostDocReview.vue?vue&type=style&index=0&id=4024f3b8&prod&lang=css&"
import style1 from "./PostDocReview.vue?vue&type=style&index=1&id=4024f3b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024f3b8",
  null
  
)

export default component.exports